import angular from 'angular';
// TODO: https://graystep.atlassian.net/browse/GR-2153
import webSpinner from './webspinner-ajs/webspinner-ajs';
import { BooksServicesProvider } from './services/BooksServices';
import { DomainNameCheckService } from './services/DomainNameCheck';
import { SystemLoginServicesProvider } from './services/SystemLoginServices';
import { WatcherFactory } from './services/Watcher';
import { AccountAdminInfoConfig } from './services/NewBooksData/accounts/AccountAdminInfo';
import { OrganizationConfig } from './services/NewBooksData/entities/Organization';
import { AccountInfoConfig } from './services/NewBooksData/AccountInfo';
import { AccountTypeConfig } from './services/NewBooksData/AccountType';
import { AddressConfig } from './services/NewBooksData/Address';
import { ClassInfoConfig } from './services/NewBooksData/ClassInfo';
import { EntityInfoConfig } from './services/NewBooksData/EntityInfo';
import { FundraiserConfig } from './services/NewBooksData/Fundraiser';
import { JournalItemConfig } from './services/NewBooksData/JournalItem';
import { ProcessorConfig } from './services/NewBooksData/Processor';

export default angular
  .module('csm.books.services', [webSpinner])
  .provider('BooksServices', BooksServicesProvider)
  .service('DomainNameCheck', DomainNameCheckService)
  .provider('SystemLoginServices', SystemLoginServicesProvider)
  .factory('Watcher', WatcherFactory)
  .config(AccountAdminInfoConfig)
  .config(OrganizationConfig)
  .config(AccountInfoConfig)
  .config(AccountTypeConfig)
  .config(AddressConfig)
  .config(ClassInfoConfig)
  .config(EntityInfoConfig)
  .config(FundraiserConfig)
  .config(JournalItemConfig)
  .config(ProcessorConfig)
  /**
   * TypeFactory is reliant on SERVER being available to initialize properly.
   * So we defer its initialization to the run block. This is because on the login
   * page we don't have access to SERVER yet, which will cause errors if we try to
   * initialize it too early. Therefore, we check for SERVER before initializing.
   *
   * Why is this an issue?
   * When we bundle our Javascript code, that bundle has access to all of the modules
   * at the moment of bundling. Then in places like booksApp.ascx, we bring in the entire
   * bundle with a script tag. This means that even on the login page, the code for
   * csmBooks (which includes webspinner-ajs and TypeFactory) is loaded in. Hence why
   * TypeFactory attempts to initialize on the login page where SERVER is not available.
   *
   * Why do we need TypeFactory to initialize here? And not in webspinner-ajs?
   * Because many of the initial type configurations are registered here. If we
   * initialized TypeFactory in webspinner-ajs or within data.js of webspinner-ajs,
   * we would be creating types from empty config lists so the html of the page will
   * load but it would be stuck in an infinite loading state as it waits for types that
   * were never created. An example of this is Our School in ASBWorks.
   */
  .run([
    '$injector',
    function ($injector) {
      // Only run TypeFactory if SERVER is available (not on login page)
      if ($injector.has('SERVER')) {
        $injector.get('TypeFactory');
      }
    }
  ]).name;
